export default __webpack_public_path__ + "static/media/profilemobile-changeava.d27b5767.svg";